<template>
  <div class="detail">
    <div class="nav">
      <img
        class="back"
        src="../../../assets/workOrder/back.png"
        alt=""
        @click="onClickBack"
      />
      <p class="title">工单详情</p>
      <div></div>
    </div>
    <div class="head_info">
      <div class="top">
        <div class="left">
          {{ (queryInfo.bizName && queryInfo.bizName.split("")[0]) || "-" }}
        </div>
        <div class="right">
          <div class="text">
            <div class="bizName">{{ `${queryInfo.bizName || "--"}` }}</div>
          </div>
          <div class="sgInfo">
            <span class="goodstype">{{ queryInfo.goodsType || "--" }}</span>
            <span class="goodsWeight">{{ queryInfo.goodsWeight || 0 }}吨</span>
          </div>
        </div>
      </div>
      <div class="middle flex">
        <div class="left">
          <div>
            <p class="tip">始发地：</p>
            <p class="place">{{ queryInfo.originPlace || "--" }}</p>
          </div>
          <div>
            <p class="tip">目的地：</p>
            <p class="place">{{ queryInfo.destinationPlace || "--" }}</p>
          </div>
        </div>
      </div>
      <div class="info">
        <p><span>开航时间：</span>{{ queryInfo.khTime || "--" }}</p>
      </div>
    </div>

    <div class="list_cell" v-for="item in list" :key="item.id">
      <div class="top flex">
        <!-- <img class="icon" src="@/assets/workOrder/shipIcon.png" /> -->
        <div class="inner flex">
          <p class="title">{{ item.shipName }}</p>
          <div class="btns">
            <img
              src="../../../assets/dispatch/dai.png"
              style="width: 67px; height: 23px"
              alt=""
              srcset=""
              v-if="item.state == 1"
            />
            <img
              src="../../../assets/dispatch/bo.png"
              style="width: 67px; height: 23px"
              alt=""
              srcset=""
              v-if="item.state == 2"
            />
            <img
              src="../../../assets/dispatch/submitted.png"
              style="width: 67px; height: 23px"
              alt=""
              srcset=""
              v-if="item.state == 3"
            />
            <img
              src="../../../assets/dispatch/reviewed.png"
              style="width: 67px; height: 23px"
              alt=""
              srcset=""
              v-if="item.state == 4"
            />
          </div>
        </div>
      </div>
      <div class="view">
        <div class="inner">
          <p class="text_info">
            安装人员：<span>{{ item.installPerson }}</span>
          </p>
          <p class="text_info">
            提交时间：<span>{{ item.submitTime }}</span>
          </p>
          <p class="text_info" v-if="item.state == 4">
            审核时间：<span>{{ item.checkTime }}</span>
          </p>
        </div>
      </div>
      <div class="line"></div>

      <!-- 展示驳回理由 -->
      <div style="width: 100%; text-align: right">
        <span class="type4" @click="renewal(item)"> 更换安装人员</span>
      </div>
    </div>
    <van-popup v-model="showAction" position="center" class="showAction">
      <div class="wrapper">
        <div class="block">
          <p class="title"> 更换安装人员</p>
          <van-checkbox-group
            v-model="result"
            direction="horizontal"
            :disabled="kdhg"
          >
            <van-checkbox
              v-for="item in installList"
              :key="item.id"
              :name="item.name"
              class="horizontallist"
            >
              {{ item.name }}</van-checkbox
            >
          </van-checkbox-group>

          <div class="btns">
            <div class="reject" @click="onClickState(1)">取消</div>
            <div class="pass" @click="onClickState(0)">更换</div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  orderDetail,
  updateInstallList,
  WorkUserList,
} from "@/utils/network/interface";
export default {
  name: "orderDetail",
  data() {
    return {
      kdhg: false,
      activeNames: [],
      result: [],
      queryInfo: {},
      list: [],
      showAction: false,

      currenItem: {},

      installPerson: "",
      compoment: "",
      installList: [],
    };
  },
  created() {
    this.queryInfo = JSON.parse(this.$route.query.info);
  },
  mounted() {
    this.getDetail();
    this.installFrom();
    // localStorage.setItem("path","workList3")
  },
  methods: {
    installFrom() {
      WorkUserList().then((res) => {
        if (res.code === 200) {
          this.installList = res.data;
          console.log(res);
        }
      });
    },
    getDetail() {
      orderDetail({ id: this.queryInfo.id }).then((res) => {
        if (res.code === 200) {
          this.list = res.data;
          console.log(res, "321");
        }
      });
    },
    onClickBack() {
      this.$router.go(-1);
    },
    renewal(item) {
      console.log(item);
      this.currenItem=item
      this.showAction = true;
    },

    onClickState(type) {
      if (type == 1) {
        this.result = [];
        this.currenItem = {};

        this.showAction = false;

        this.installPerson = "";
        return;
      } else if (type == 0) {
        let arrs = this.result + "";
        console.log(arrs);
        this.installPerson = arrs;
        if (this.installPerson.length <= 0)
          return this.$toast("请先选择安装人员");
        updateInstallList({
          id: this.currenItem.id,
          installPerson: this.installPerson,
        }).then((res) => {
          if (res.code == 200) {
            this.getDetail();

            this.showAction = false;

            this.installPerson = "";
            this.result = [];
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.detail {
  background: url("../../../assets/workOrder/detailBg.png") 0 0 no-repeat;
  background-size: 100% 240px;
  min-height: 240px;
  padding-top: 36px;

  .nav {
    display: flex;

    .title {
      height: 16px;
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      color: #ffffff;
      line-height: 16px;
      margin: 0 auto;
      // margin-left: -26px;
    }

    .back {
      width: 18px;
      height: 18px;
      margin-top: -2px;
      margin-left: 8px;
    }

    div {
      width: 18px;
      margin-right: 8px;
    }
  }

  .head_info {
    margin: 0 auto;
    margin-top: 20px;
    width: 95%;
    background-color: #ffffff;
    border-radius: 5px;
    padding: 13px 8px;

    .top {
      display: flex;
      margin-bottom: 10px;
      border-bottom: 1px solid #eeeeee;
      padding-bottom: 10px;

      .left {
        flex: 0 0 40px;
        height: 40px;
        font-size: 20px;
        line-height: 40px;
        text-align: center;
        background: #44b1f9;
        border-radius: 6px;
        color: #fff;
        margin-right: 10px;
      }

      .right {
        .text {
          display: flex;
          margin-bottom: 5px;
        }
      }

      .bizName {
        font-size: 16px;
        font-family: Source Han Sans CN, Source Han Sans CN-Medium;
        font-weight: 500;
        color: #333333;
        padding: 2px 0;
        line-height: 16px;
        margin-bottom: 2px;
      }

      .sgInfo {
        span {
          display: inline-block;
          padding: 2px 5px;
          font-size: 12px;
          line-height: 1.1;
        }

        .goodstype {
          margin-right: 10px;
          background: rgba(31, 181, 74, 0.15);
          color: #1fb54a;
        }

        .goodsWeight {
          margin-right: 10px;
          background: rgba(255, 0, 0, 0.15);
          color: #ff0000;
        }
      }
    }

    .middle {
      vertical-align: middle;
      border-radius: 5px;
      color: #333;
      align-items: center;
      justify-content: space-between;

      .left {
        background: url("../../../assets/workOrder/itemLeft.png") left center
          no-repeat;
        background-size: 8px 44px;
        min-height: 44px;
        padding-left: 15px;

        > div:first-child {
          margin-bottom: 6px;
        }

        .tip,
        .place {
          display: inline-block;
          vertical-align: middle;
          font-size: 13px;
          line-height: 28px;
        }

        .tip {
          color: #999;
          margin-right: 5px;
        }

        .place {
          font-weight: bold;
          color: #000;
        }
      }
    }
    .info {
      p {
        font-size: 13px;
        line-height: 2;
        color: #333;
        span {
          color: #999;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }
  }

  .action_view {
    margin: 0 auto;
    margin-top: 10px;
    width: 95%;
    height: 48px;
    background-color: #ffffff;
    border-radius: 5px;
  }

  .list_cell {
    margin: 0 auto;
    margin-top: 10px;
    width: 95%;
    background-color: #ffffff;
    border-radius: 5px;
    padding-left: 15px;
    padding-right: 15px;
    margin-bottom: 10px;

    /deep/.titco {
      font-size: 14px;
      font-weight: 500;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      color: #666666;
    }

    /deep/.van-collapse-item__content {
      font-size: 12px;
      font-weight: normal;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      color: #999999;
    }

    .line {
      width: 100%;
      height: 1px;
      background: #eeeeee;
      margin: 0 auto;
      margin-bottom: 10px;
    }

    .view {
      display: flex;

      .line1 {
        width: 4px;
        height: 33px;
        // margin-top: 20px;
        margin-right: 20px;
        margin-left: 10px;
        margin-top: 2px;
      }

      .line2 {
        width: 4px;
        height: 57px;
        // margin-top: 20px;
        margin-right: 20px;
        margin-left: 10px;
        margin-top: 2px;
      }
    }

    .top {
      width: 100%;
      padding: 12px 0;
      align-items: center;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .icon {
        flex: 0 0 28px;
        display: block;
        width: 28px;
        height: 28px;
        margin-right: 15px;
      }

      .inner {
        // flex: 0 0 calc(100% - 43px);
        justify-content: space-between;
        width: 100%;
        line-height: 28px;
        font-size: 14px;

        .btn {
          display: block;
          height: 28px;
          line-height: 26px;
          border-width: 1px;
          border-style: solid;
          padding: 0 10px;
          min-width: 66px;
          text-align: center;
          border-radius: 30px;

          &1 {
            background: #44b1f9;
            border-color: #44b1f9;
            color: #fff;
          }

          &2 {
            background: #999999;
            border-color: #999999;
            color: #fff;
          }

          &3 {
            background: rgba(68, 177, 249, 0.15);
            border-color: #44b1f9;
            color: #44b1f9;
          }

          &4 {
            background: rgba(153, 153, 153, 0.15);
            border-color: #999;
            color: #999;
          }
          &5 {
            // background: rgba(153, 153, 153, 0.15);
            border-color: red;
            color: red;
          }
        }
      }
    }

    .inner {
      font-size: 14px;
      // padding: 10px 0;
      bottom: 1px solid #999999;
      line-height: 2;
    }

    .text_info {
      height: 12px;
      font-size: 12px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      text-align: center;
      color: #999999;
      line-height: 12px;
      text-align: left;
      margin-bottom: 12px;
    }
  }

  .showAction {
    width: 320px;
    // height: 250px;
    // min-height: 200px;
    max-height: 300px;
    background: #ffffff;
    border-radius: 20px;
    padding: 20px;
    line-height: 2;
    font-size: 14px;
    font-family: Source Han Sans CN, Source Han Sans CN-Medium;
    font-weight: 500;
    text-align: left;
    color: #666666;

    .title {
      margin-bottom: 10px;
    }

    .horizontallist {
      margin-bottom: 12px;
    }

    .area {
      margin: 0 auto;
      width: 100%;
      height: 107px;
      background: #eeeeee;
      border: 1px solid #44b1f9;
      border-radius: 5px;
      box-sizing: border-box;
      padding: 10px;
      resize: none;
    }

    .btns {
      margin-top: 30px;
      text-align: center;
      width: 100%;

      .reject {
        width: 88px;
        height: 28px;
        border-radius: 5px;
        background-color: #999999;
        color: white;
        text-align: center;
        line-height: 28px;
        display: inline-block;
        margin: 0 15px;
      }

      .pass {
        width: 88px;
        height: 28px;
        border-radius: 5px;
        color: white;
        text-align: center;
        line-height: 28px;
        background-color: #44b1f9;
        display: inline-block;
        margin: 0 15px;
      }
    }
  }
}
.type4 {
  display: inline-block;
  padding: 0 15px;
  height: 26px;
  background: rgba(252, 152, 68, 0.15);
  border: 1px solid #fc9c49;
  border-radius: 5px;
  text-align: center;
  font-size: 14px;
  font-family: Source Han Sans CN, Source Han Sans CN-Medium;
  font-weight: 500;
  text-align: center;
  color: #fc9c49;
  line-height: 26px;
  margin-right: 5px;
  margin-bottom: 10px;
}
.wrapper {
    .block {
       .title {
           text-align: center;
           font-size: 16px;
           color: #000;
           font-weight: 500;
       } 
    }
}
</style>